module.exports = __webpack_public_path__ + "media/bit.37c995c8.ogg";